import Service from "../../service/index";


const Hospital = {
    namespaced: true,
    state: {
        hospital: [],
    },
    mutations: {
        GET_HOSPITAL: (state, data) => {
            state.hospital = data;
        },
    },
    actions: {
        setHospital({commit}){
            return Service.Hospital.getHospital()
                .then(data=>{
                    commit("GET_HOSPITAL",data);
                })
        },
    }
};
export default Hospital;
